export default __webpack_public_path__ + "static/media/cacodemon.ae66bb2d.png";